module.exports = __webpack_public_path__ + "static/img/naturalCircle5.22d7992.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle5.svg
// module id = 2EpT
// module chunks = 1